import { onCLS, onFID, onLCP, onFCP, onTTFB, ReportCallback } from 'web-vitals';

export default function webVitals(sendWebVitals: ReportCallback): void {
  onLCP(sendWebVitals);
  onFID(sendWebVitals);
  onCLS(sendWebVitals);
  onFCP(sendWebVitals);
  onTTFB(sendWebVitals);
}
